import axiosClient from "../axiosClient";
import { ref, inject } from "vue";
import { useRouter } from "vue-router";

export default function useUserTypes() {
  const userTypes = ref({});
  const userType = ref({});
  const validationErrors = ref({});
  const isLoading = ref(false);

  const router = useRouter();
  const swal = inject("$swal");

  const getUserTypes = async (
    page = 1,
    search_id = "",
    search_name_en = "",
    search_name_ar = "",
    search_global = "",
    order_column = "created_at",
    order_direction = "desc",
    per_page = 10
  ) => {
    axiosClient
      .get(
        "/user-types?" +
          "page=" +
          page +
          "&search_id=" +
          search_id +
          "&search_name_en=" +
          search_name_en +
          "&search_name_ar=" +
          search_name_ar +
          "&search_global=" +
          search_global +
          "&order_column=" +
          order_column +
          "&order_direction=" +
          order_direction +
          "&per_page=" +
          per_page
      )
      .then((response) => {
        userTypes.value = response.data;
      })
      .catch((error) => {
        if (error.response?.data) {
          validationErrors.value = error.response.data.errors;

          swal({
            icon: "error",
            title: "Server error, please try again.",
          });
        }
      });
  };

  const getUserType = async (id) => {
    axiosClient.get("/user-types/" + id).then((response) => {
      userType.value = response.data.data;
    });
  };

  const storeUserType = async (userType) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    let serializedUserType = new FormData();
    for (let item in userType) {
      if (userType.hasOwnProperty(item)) {
        serializedUserType.append(item, userType[item]);
      }
    }

    axiosClient
      .post("/user-types", serializedUserType)
      .then((response) => {
        router.push({ name: "user-types.index" });
        swal({
          icon: "success",
          title: "user type saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const updateUserType = async (userType) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    axiosClient
      .put("/user-types/" + userType.id, userType)
      .then((response) => {
        router.push({ name: "user-types.index" });
        swal({
          icon: "success",
          title: "User type saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const deleteUserType = async (id) => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#ef4444",
      timer: 20000,
      timerProgressBar: true,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient
          .delete("/user-types/" + id)
          .then((response) => {
            getUserTypes();
            router.push({ name: "user-types.index" });
            swal({
              icon: "success",
              title: "User type deleted successfully",
            });
          })
          .catch((error) => {
            swal({
              icon: "error",
              title: error,
            });
          });
      }
    });
  };

  return {
    userTypes,
    userType,
    getUserTypes,
    getUserType,
    storeUserType,
    validationErrors,
    isLoading,
    updateUserType,
    deleteUserType,
  };
}
